export default "__VITE_ASSET__B2YDbyvb__"